// @ts-nocheck
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import Img, { ImgProps } from "@insite/mobius/Img";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import {
    getProductLineIsActive,
    getProductLineTitle,
    getProductLineUrl,
} from "@store/Framework/Common/Utilities/productLineUtilities";
import { ProductLineComponentModel } from "@store/Library/Components/ProductLine/ProductLine";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { useSettingsCollection } from "@toolkit/Framework/Store/Context/ContextHooks";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import { focusStyles } from "@toolkit/Themes/common/mixins/common";
import React, { FC } from "react";
import { css } from "styled-components";

export interface ProductLineProductImageProps {
    productInfo?: ProductInfo;
    productLine: ProductLineComponentModel;
}

export interface ProductLineProductImageStyles {
    wrapper?: InjectableCss;
    link?: ClickablePresentationProps;
    img?: ImgProps;
}

export const productLineProductImageStyles: ProductLineProductImageStyles = {
    wrapper: {
        css: css`
            ${spacingStyles(null, pxToRem(10))}
            display: flex;
            justify-content: center;
        `,
    },
    link: {
        css: css`
            ${focusStyles()}
        `,
    },
    img: {
        css: css`
            width: ${pxToRem(116)};
            max-width: 100%;
            height: auto;
        `,
    },
};

const styles = productLineProductImageStyles;

const ProductLineProductImage: FC<ProductLineProductImageProps> = ({ productInfo, productLine }) => {
    const trackSelectItem = ga.use.trackSelectItem({ items: productLine as ProductModel });
    const { extensionCatalogSettings } = useSettingsCollection();

    if (!productLine) {
        return null;
    }

    const isActive = getProductLineIsActive(productLine);
    const url = getProductLineUrl(productLine, productInfo);

    const altText = productLine.imageAltText || productLine.altText || getProductLineTitle(productLine);
    const loading = typeof productLine.idx === "number" && productLine.idx < 3 ? "eager" : "lazy";
    const src =
        productLine.smallImagePath ||
        productLine.properties?.smallImagePath ||
        extensionCatalogSettings.notFoundSmallImagePath;

    return (
        <StyledWrapper {...styles.wrapper}>
            <Clickable
                {...styles.link}
                href={isActive && url ? url : undefined}
                onClick={isActive && url ? () => trackSelectItem() : undefined}
                data-test-selector="productImage"
            >
                <Img {...styles.img} altText={altText} loading={loading} src={src} />
            </Clickable>
        </StyledWrapper>
    );
};

export default ProductLineProductImage;
